import {AfterViewInit, Component, OnInit} from '@angular/core';
import {ViewportScroller} from '@angular/common';
import {ActivatedRoute} from '@angular/router';
import {SettingService} from '../../lib/core/common/settings.service';

@Component({
  selector: 'app-home-six',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, AfterViewInit {

  constructor(public settings: SettingService,
              private route: ActivatedRoute,
              private viewportScroller: ViewportScroller) {
  }

  public onClick(elementId: string): void {
    this.viewportScroller.scrollToAnchor(elementId);
  }

  ngOnInit() {
    this.settings.enableLoader();
  }

  ngAfterViewInit(): void {
    this.route.fragment.subscribe(async fragment => {
      if (fragment) {
        await this.delay(500);
        this.viewportScroller.scrollToAnchor(fragment);
      }
    });
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

}
